"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardFooter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var chevron_svg_1 = __importDefault(require("../../assets/chevron.svg"));
var LeaderboardFooter = function (_a) {
    var toggleList = _a.toggleList, collapsed = _a.collapsed;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "leaderboard-body--footer" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ onClick: toggleList }, { children: collapsed ? "Hide the entire winners list" : "See the entire winners list" })), (0, jsx_runtime_1.jsx)("img", { className: (0, clsx_1.default)(collapsed && "leaderboard-body--footer--inverted-image"), onClick: toggleList, src: chevron_svg_1.default })] })));
};
exports.LeaderboardFooter = LeaderboardFooter;
